<div class="main-container">
    <div class="inner-content large-width" [class.no-top-margin]="inlineEditor">
        <div class="p-3">
            <!-- Inline editor header -->
            <div class="members-header" *ngIf="inlineEditor && editing; else listHeader">
                <div>
                    <h1 class="title">
                        <ng-container *ngIf="editingDataSource; else addTitle" >{{ editingDataSource?.name }}</ng-container>
                        <ng-template #addTitle>
                            <span i18n="Add Data Source Header@@adminDataSourcesAddHeader">Add Data Source</span>
                        </ng-template>
                    </h1>
                </div>
                <div>
                    <button mat-stroked-button color="primary" (click)="onInlineEditorClosed()">
                        <mat-icon>arrow_back</mat-icon>
                        <ng-container i18n="Back Button@@adminDataSourcesBackButton">Back</ng-container>
                    </button>
                </div>
            </div>
            <ng-template #listHeader>
            <div class="members-header">
                <div>
                    <h1 class="title" i18n="Data Sources Title@@adminDataSourcesTitle">Data Sources</h1>
                    <span class="subtitle" i18n="External Data Sources Subtitle@@adminDataSourcesSubtitle"></span>
                </div>
                <div>
                    <button mat-flat-button color="primary" (click)="inlineEditor ? startInlineEditor() : onDataSourceDialog()">
                        <mat-icon>add</mat-icon>
                        <ng-container i18n="Add Data Source Button@@adminDataSourcesAddButton">
                            Add data source
                        </ng-container>
                    </button>
                </div>
            </div>
            </ng-template>

            <div class="mt-7" *ngIf="!(inlineEditor && editing); else inlineEditorTpl">
                <div class="mb-2">
                    <button mat-flat-button color="primary" (click)="onExport()" class="mr-2">
                        <mat-icon>download</mat-icon>
                        <ng-container i18n="Export Data Sources Button@@adminDataSourcesExportButton">
                            Export data sources
                        </ng-container>
                    </button>

					<button mat-flat-button color="primary" (click)="onImport()">
						<mat-icon>upload</mat-icon>
						<ng-container i18n="Import Data Sources Button@@adminDataSourcesImportButton">
							Import data sources
						</ng-container>
					</button>
				</div>

				<div class="collection-table-container user-business-list">
                    <app-collection-container
                        [collection]="dataSourcesListTableCollection"
                        (onLinkedOutput)="onLinkedClick($event)"
                        (eventOutput)="onRowAction($event)"
                    >
                    </app-collection-container>
                </div>
            </div>
            <ng-template #inlineEditorTpl>
                <!-- Inline editor uses the same component as the dialog, but embedded -->
                <app-admin-data-source-dialog
                    [inline]="true"
                    [inlineDataSource]="editingDataSource"
                    [showCloseButton]="false"
                    (close)="onInlineEditorClosed($event)">
                </app-admin-data-source-dialog>
            </ng-template>
        </div>
    </div>
</div>
